/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_A_Notes_HeaderInputs */



/**
* | output |
* | --- |
* | "Group A Notes" |
*
* @param {Compare_Event_Groups_Csv_Group_A_Notes_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_a_notes_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_A_Notes_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_A_Notes_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes du groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe A Notizen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Appunti del Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания группы А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas del Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("A组笔记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAに関する注記")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह ए नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas do Grupo A")
	return /** @type {LocalizedString} */ ("Group A Notes")
});